import React, { useId } from "react";
import { Mic } from "lucide-react";
import { IconButton } from "../../atoms/IconButton";
import { Tooltip } from "../../atoms/Tooltip";
import { VisuallyHidden } from "../../atoms/VisuallyHidden";
import { VOICE_HINT, VOICE_START_LABEL, VOICE_STOP_LABEL } from "../../../services/speech/speech.copy";
import type { MicButtonProps } from "./MicButton.types";

/** A microphone toggle for any text field: start and stop, with the reason shown when it can't be used. */
export const MicButton: React.FC<MicButtonProps> = ({
  isListening,
  onToggle,
  disabledReason = null,
  startLabel = VOICE_START_LABEL,
  stopLabel = VOICE_STOP_LABEL,
  size,
  className,
}) => {
  const name = isListening ? stopLabel : startLabel;
  const reasonId = useId();
  return (
    <Tooltip label={disabledReason ?? (isListening ? name : VOICE_HINT)} position="bottom" multiline className={className}>
      <IconButton
        icon={Mic}
        aria-label={name}
        size={size}
        $active={isListening}
        aria-disabled={Boolean(disabledReason)}
        aria-describedby={disabledReason ? reasonId : undefined}
        onClick={onToggle}
      />
      {disabledReason ? <VisuallyHidden id={reasonId}>{disabledReason}</VisuallyHidden> : null}
    </Tooltip>
  );
};

export default MicButton;
